export default () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="8" cy="8" r="7.5" fill="#fff" stroke="#038331" />
		<path d="m4.571 9.143 2.857 2.286 4-5.715" stroke="#038331" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);
